import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  Me = '[STORE | CONTROL | AUTH] Me',
  MeSuccess = '[STORE | CONTROL | AUTH] Me Success',
  ClearSession = '[STORE | CONTROL | AUTH] Clear Session',
  /**
   * Request
   */
  MeRequest = '[REQUEST | CONTROL | AUTH] Me Request',
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Me
 */
export class Me {
  public static readonly type = ActionTypes.Me;
}

/**
 * Me Success
 */
export class MeSuccess {
  public static readonly type = ActionTypes.MeSuccess;

  public constructor(public user: FlatModels.UserEntityModels.AuthUser) {
  }
}

/**
 * Clear Session
 */
export class ClearSession {
  public static readonly type = ActionTypes.ClearSession;
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Me Request
 */
export class MeRequest {
  public static readonly type = ActionTypes.MeRequest;
}

// </editor-fold>
